angular.module('ikeweb.error').value('cloudCodeErrors', {
    DUPLICATE: 'duplicate',
    USER_EXISTS: 'user_exists',
    FOLDER_NAME_EMPTY: 'folder_name_empty'
});



//////////////////
// WEBPACK FOOTER
// ./src/client/error/cloud.code.errors.js
// module id = 158
// module chunks = 0